import { Button, Stack, Box } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import React from "react";
import DetailsTreeContainer from "../../../../shared-components/hoa-view-details-draw-container";
import {
	StringComponentForOverView,
	ArrayComponentForOverView,
	ObjectComponentForOverView,
} from "../../../../shared-components/hoa-view-tabs-item-component";
import HoaEventComponent from "../hoa-view-events";
import HoaOnboardingView from "../../../../components/hoa-onboarding/hoa-onboarding-view";
import datastore from "../../../../store/hoa-datastore";

const processItem = (item: any): React.ReactNode[] =>
	Object.entries(item).flatMap(([key, value]) => {
		if (typeof value === "string") {
			return <StringComponentForOverView key={key} title={key} value={value} />;
		} else if (Array.isArray(value)) {
			return <ArrayComponentForOverView key={key} title={key} value={value} />;
		} else if (typeof value === "object") {
			return (
				<ObjectComponentForOverView processItem={processItem} value={value} title={key} />
			);
		}
		return null;
	});

const OverViewDetailsComponent: React.FC<{ details: any; onViewMunicipalityDetailsClick: any, onboardingDataState: any }> = ({
	details,
	onViewMunicipalityDetailsClick,
	onboardingDataState
}) => {
	return  (
		<>
			<HoaOnboardingView onboardingDataState={onboardingDataState}/>
			{Object.entries(details).map(([key, value]: any) => {
		return (
			value?.length > 0 && (
				<Stack sx={{ position: "relative" }} key={key} borderBottom={"1px solid #E8E8E8"}>
					<Stack m={3}>
						<span className="text-3E3E3E-18px">{key}</span>
						{key !== "HOA Events" ? (<DetailsTreeContainer key={key} data={value} processItem={processItem} />) : (
							<div>
								<HoaEventComponent hoaEvents={details["HOA Events"]} />
							</div>
						)}
					</Stack>
					{key === "Municipality" && (
						<>
							<Button
								onClick={() => onViewMunicipalityDetailsClick()}
								style={{
									textTransform: "capitalize",
									width: "176px",
									height: "40px",
								}}
								variant="outlined"
								startIcon={<OpenInNewIcon />}
								sx={{ position: "absolute", top: "20px", right: "20px" }}
							>
								<span className="text-3E3E3E-14px bold">View More Details</span>
							</Button>
						</>
					)}
				</Stack>
			)
				);
			})}
		</>
	);
}
export default OverViewDetailsComponent;
